export enum TransportSubMode {
  unknown = 'unknown',
  none = 'none',
  vasttagen = 'vasttagen',
  longDistanceTrain = 'longDistanceTrain',
  regionalTrain = 'regionalTrain',
}
